import { WsButtonDisplayAction } from "../ChatAction";

export interface DisplayWsButtonParams {
    id: string;
    text: string;
    pressBehavior: "disabled" | "spinning" | "none";
    isPressed?: boolean;
    isDismissing?: boolean;
}

export default function displayWsButton(params: DisplayWsButtonParams): WsButtonDisplayAction {
    return {
        type: "ws_button_display",
        detail: {
            id: params.id,
            text: params.text,
            pressBehavior: params.pressBehavior,
            isPressed: params.isPressed,
            isDismissing: params.isDismissing,
            timestamp: +new Date()
        }
    };
}
